const hamburger = document.getElementById('hamburger');
const navBackDrop = document.getElementById('nav-backdrop');
const mobileMenu = document.getElementById('navbar-mobile');

const hamburgerClick = () => {
    if (mobileMenu.classList.contains('navbar-out') || navBackDrop.classList.contains('not-visible')) {
        mobileMenu.classList.remove('navbar-out');
        mobileMenu.classList.add('navbar-in');
        navBackDrop.classList.remove('not-visible');
        navBackDrop.classList.add('is-visible');
    } else if (mobileMenu.classList.contains('navbar-in') || navBackDrop.classList.contains('is-visible')) {
        mobileMenu.classList.remove('navbar-in');
        mobileMenu.classList.add('navbar-out');
        navBackDrop.classList.remove('is-visible');
        navBackDrop.classList.add('not-visible');
    } else {
        mobileMenu.classList.add('navbar-in');
        navBackDrop.classList.add('is-visible');
    }
};

const navBackDropClick = () => {
    navBackDrop.classList.remove('is-visible');
    navBackDrop.classList.add('not-visible');

    mobileMenu.classList.remove('navbar-in');
    mobileMenu.classList.add('navbar-out');
};

if ( hamburger !== null) {
    hamburger.addEventListener('click', hamburgerClick);
}
if ( navBackDrop !== null) {
    navBackDrop.addEventListener('click', navBackDropClick);
}
